<h3 class="widget-title">{{ title() }}</h3>

<!-- Selected Doctor Display -->
@if (currentDoctor) {
  <mat-card class="selected-doctor-card">
    <mat-card-content>
      <div class="selected-doctor-header">
        <div class="doctor-avatar selected">
          @if (currentDoctor.profilePictureUrl) {
            <img [src]="currentDoctor.profilePictureUrl" [alt]="currentDoctor.name" class="avatar-img">
          } @else {
            <mat-icon>person</mat-icon>
          }
        </div>
        <div class="selected-doctor-info">
          <span class="doctor-name">{{ currentDoctor.name }}</span>
          <div class="doctor-details">
            @if (currentDoctor.specialty) {
              <span class="detail-item">{{ currentDoctor.specialty.name }}</span>
            }
            @if (currentDoctor.facility) {
              <span class="detail-item">{{ currentDoctor.facility.name }}</span>
            }
          </div>
          <div class="doctor-badges">
            <mat-chip-set>
              <mat-chip [color]="getDoctorTypeColor(currentDoctor)" highlighted>
                {{ getDoctorTypeLabel(currentDoctor) }}
              </mat-chip>
              @if (currentDoctor.canReceiveDirectReferral) {
                <mat-chip color="primary" highlighted>
                  Direct Referral
                </mat-chip>
              }
            </mat-chip-set>
          </div>
        </div>
        <button mat-icon-button color="warn" (click)="clearSelection()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </mat-card-content>
  </mat-card>
} @else {
  <!-- Filter Options -->
  <div class="filter-row">
    <mat-form-field appearance="outline" class="filter-field">
      <mat-label>Filter by Specialty</mat-label>
      <mat-select [value]="selectedSpecialtyId()" (selectionChange)="onSpecialtyChange($event.value)">
        <mat-option [value]="null">All Specialties</mat-option>
        @for (specialty of specialties(); track specialty.id) {
          <mat-option [value]="specialty.id">{{ specialty.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-field">
      <mat-label>Filter by Facility</mat-label>
      <mat-select [value]="selectedFacilityId()" (selectionChange)="onFacilityChange($event.value)">
        <mat-option [value]="null">All Facilities</mat-option>
        @for (facility of facilities(); track facility.id) {
          <mat-option [value]="facility.id">{{ facility.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    @if (selectedSpecialtyId() || selectedFacilityId()) {
      <button mat-icon-button (click)="clearFilters()" matTooltip="Clear filters">
        <mat-icon>filter_alt_off</mat-icon>
      </button>
    }
  </div>

  <!-- Search -->
  <div class="search-container">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Search Doctors</mat-label>
      <mat-icon matPrefix>search</mat-icon>
      <input matInput
             type="text"
             [value]="searchQuery()"
             (input)="onSearchInput($event)"
             placeholder="Search by name...">
      @if (searchQuery().length > 0) {
        <button mat-icon-button matSuffix (click)="clearSearch()">
          <mat-icon>clear</mat-icon>
        </button>
      }
    </mat-form-field>

    @if (showResults()) {
      <div class="search-results mat-elevation-z3">
        @if (isSearching()) {
          <div class="searching">
            <mat-spinner diameter="24"></mat-spinner>
            <span>Searching...</span>
          </div>
        } @else if (searchResults().length === 0) {
          <div class="no-results">
            <span>No doctors found</span>
          </div>
        } @else {
          @for (doctor of searchResults(); track doctor.id) {
            <mat-card class="result-card" (click)="selectDoctor(doctor)">
              <mat-card-content>
                <div class="result-header">
                  <div class="doctor-avatar">
                    @if (doctor.profilePictureUrl) {
                      <img [src]="doctor.profilePictureUrl" [alt]="doctor.name" class="avatar-img">
                    } @else {
                      <mat-icon>person</mat-icon>
                    }
                  </div>
                  <div class="result-info">
                    <span class="result-name">{{ doctor.name }}</span>
                    <div class="result-details">
                      @if (doctor.specialty) {
                        <span class="detail-item">{{ doctor.specialty.name }}</span>
                      }
                      @if (doctor.facility) {
                        <span class="detail-item">{{ doctor.facility.name }}</span>
                      }
                    </div>
                    <div class="result-badges">
                      <mat-chip-set>
                        <mat-chip [color]="getDoctorTypeColor(doctor)" highlighted size="small">
                          {{ getDoctorTypeLabel(doctor) }}
                        </mat-chip>
                        @if (doctor.canReceiveDirectReferral) {
                          <mat-chip color="primary" highlighted size="small">
                            Direct Referral
                          </mat-chip>
                        }
                      </mat-chip-set>
                    </div>
                  </div>
                  <mat-icon color="primary">chevron_right</mat-icon>
                </div>
              </mat-card-content>
              <mat-divider></mat-divider>
            </mat-card>
          }
        }
      </div>
    }
  </div>

  @if (required() && !currentDoctor) {
    <p class="required-hint">* Please select a doctor</p>
  }
}
